import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ApiWave } from "@/generated/models/ApiWave";
import { useAuth } from "@/components/auth/Auth";
import { useWaveActivityLogs } from "@/hooks/useWaveActivityLogs";
import { WaveLeaderboardRightSidebarActivityLog } from "./WaveLeaderboardRightSidebarActivityLog";
import { useIntersectionObserver } from "@/hooks/useIntersectionObserver";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
interface WaveLeaderboardRightSidebarActivityLogsProps {
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
}
export const WaveLeaderboardRightSidebarActivityLogs: React.FC<WaveLeaderboardRightSidebarActivityLogsProps> = t0 => {
  const $ = _c(29);
  const {
    wave,
    onDropClick
  } = t0;
  const {
    connectedProfile
  } = useAuth();
  const t1 = connectedProfile?.handle ?? undefined;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["DROP_VOTE_EDIT"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1 || $[2] !== wave.id) {
    t3 = {
      waveId: wave.id,
      connectedProfileHandle: t1,
      reverse: false,
      dropId: null,
      logTypes: t2
    };
    $[1] = t1;
    $[2] = wave.id;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    logs,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    isLoading
  } = useWaveActivityLogs(t3);
  let t4;
  if ($[4] !== fetchNextPage || $[5] !== hasNextPage || $[6] !== isFetchingNextPage || $[7] !== isLoading) {
    t4 = () => {
      if (hasNextPage && !isLoading && !isFetchingNextPage) {
        fetchNextPage();
      }
    };
    $[4] = fetchNextPage;
    $[5] = hasNextPage;
    $[6] = isFetchingNextPage;
    $[7] = isLoading;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const intersectionElementRef = useIntersectionObserver(t4);
  if (logs.length === 0 && !isLoading) {
    let t5;
    let t6;
    let t7;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="tw-absolute tw-inset-0 tw-bg-gradient-to-br tw-from-primary-400/20 tw-via-indigo-500/10 tw-to-iron-800/10 tw-rounded-full tw-animate-[spin_4s_linear_infinite] desktop-hover:group-hover:tw-from-primary-400/30" />;
      t6 = <div className="tw-absolute tw-inset-0 tw-bg-gradient-to-tr tw-from-iron-800/10 tw-via-indigo-500/10 tw-to-primary-400/20 tw-rounded-full tw-animate-[spin_5s_linear_infinite] desktop-hover:group-hover:tw-to-primary-400/30" />;
      t7 = <div className="tw-absolute tw-inset-0 tw-bg-gradient-radial tw-from-primary-300/5 tw-to-transparent tw-animate-pulse" />;
      $[9] = t5;
      $[10] = t6;
      $[11] = t7;
    } else {
      t5 = $[9];
      t6 = $[10];
      t7 = $[11];
    }
    let t8;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <div className="tw-relative tw-group">{t5}{t6}{t7}<svg className="tw-size-10 tw-flex-shrink-0 tw-relative tw-text-white/60" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1" stroke="currentColor" aria-hidden="true"><path strokeLinecap="round" strokeLinejoin="round" d="M22.7 13.5L20.7005 11.5L18.7 13.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C15.3019 3 18.1885 4.77814 19.7545 7.42909M12 7V12L15 14" /></svg></div>;
      $[12] = t8;
    } else {
      t8 = $[12];
    }
    let t9;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-mt-10 tw-space-y-6 tw-text-iron-400">{t8}<div className="tw-flex tw-flex-col tw-items-center tw-gap-y-2"><span className="tw-tracking-tight tw-text-lg tw-font-semibold tw-bg-gradient-to-br tw-from-iron-200 tw-via-iron-300 tw-to-iron-400 tw-bg-clip-text tw-text-transparent">Be the First to Make a Vote</span><p className="tw-text-sm tw-text-iron-500 tw-text-center tw-mb-0 tw-max-w-64">Vote on drops to see activity updates appear here in real-time.</p></div></div>;
      $[13] = t9;
    } else {
      t9 = $[13];
    }
    return t9;
  }
  let t5;
  if ($[14] !== logs || $[15] !== onDropClick || $[16] !== wave.voting) {
    let t6;
    if ($[18] !== onDropClick || $[19] !== wave.voting) {
      t6 = log => <WaveLeaderboardRightSidebarActivityLog key={log.id} log={log} creditType={wave.voting.credit_type} onDropClick={onDropClick} />;
      $[18] = onDropClick;
      $[19] = wave.voting;
      $[20] = t6;
    } else {
      t6 = $[20];
    }
    t5 = logs.map(t6);
    $[14] = logs;
    $[15] = onDropClick;
    $[16] = wave.voting;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[21] !== isFetchingNextPage) {
    t6 = isFetchingNextPage && <div className="tw-w-full tw-h-0.5 tw-bg-iron-800 tw-overflow-hidden"><div className="tw-w-full tw-h-full tw-bg-indigo-400 tw-animate-loading-bar" /></div>;
    $[21] = isFetchingNextPage;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== intersectionElementRef) {
    t7 = <div ref={intersectionElementRef} />;
    $[23] = intersectionElementRef;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  let t8;
  if ($[25] !== t5 || $[26] !== t6 || $[27] !== t7) {
    t8 = <div className="tw-space-y-3">{t5}{t6}{t7}</div>;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  return t8;
};